import gql from "graphql-tag";

export const SubscriptionInfo = gql`
  query subscriptionInfo($userId: String!, $token: String!) {
    SubscriptionInfo(userId: $userId, token: $token) {
      sd_id
      fk_su_ID
      sd_brokerage_user_plan
      sd_basic_brokers
      sd_standard_brokers
      sd_premium_brokers
      sd_free_assistants
      sd_extra_assistants
      sd_price_pm
      sd_subscription_active
      sd_start_date
      sd_twelth_month_end
      sd_next_payment
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/Subscription/queries.js